<script>
    export default {
        props: {
            tag: {
                type: String,
                default: 'button'
            },
            isLoading: {
                type: Boolean,
                default: false
            },
            svg: {
                type: String,
                default: null
            },
            to: {
                type: Object,
                default: null
            }
        },
        render (createElement) {
            return createElement(this.tag, {
                class: [
                    'btn',
                    'relative',
                    ...(this.isLoading ? ['is-loading'] : []),
                    ...(this.svg ? ['btn-with-icon'] : [])
                ].join(' '),
                attrs: {
                    to: this.to
                }
            }, [
                createElement('div', {
                    class: [
                        'flex',
                        'w-full',
                        'h-full',
                        'items-center',
                        'justify-center',
                        ...(this.isLoading ? ['invisible'] : [])
                    ].join(' ')
                }, [
                    this.svg
                        ? createElement('base-svg', {
                            class: 'w-6 h-6 mr-2',
                            attrs: {
                                name: this.svg
                            }
                        })
                        : '',
                    this.$slots.default
                ]),
                createElement('div', {
                    class: [
                        'items-center',
                        'absolute inset-0',
                        ...(this.isLoading ? ['flex'] : ['hidden'])
                    ].join(' ')
                }, [
                    createElement('base-svg', {
                        class: 'mx-auto h-6 w-6 fill-primary-white',
                        attrs: {
                            name: 'icon-loading'
                        }
                    })
                ])
            ])
        }
    }
</script>
